import { DateTime } from 'luxon'

export class StudentBasicInfo {
	readonly StudentId!: number //學號
	readonly SemeYear!: number //學年
	readonly SemeSter!: string //學期
	readonly SemeGrade!: number //學級
	readonly CollId!: string //院系
	readonly SystId?: string //學制
	readonly Grade!: number //年級
	readonly CocsId?: string //班級
	readonly LoginStartTime!: DateTime //登入時間
	readonly LoginEndTime!: DateTime //登入到期時間
	readonly StepCreditLimits!: { [key: string]: CreditLimit } //階段學分限制
	readonly CreditLimits!: { [key: string]: CreditLimit } //計劃學分限制
	readonly CreditMax!: number //計畫學分上限(不分必選修別)
	readonly CreditMin!: number //計畫學分下限(不分必選修別)
}

export class CreditLimit {
	readonly Max?: number
	readonly Min?: number
}
